<script>
import { Scatter } from "vue-chartjs";
import utils from "../../../services/utils";

export default {
  extends: Scatter,
  props: ["activeDaysData", "missingDaysData"],
  data() {
    return {
      options: {
        title: {
          display: true,
          text: "Recent Activity"
        },
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              type: "linear",
              display: false,
              ticks: {
                min: 0,
                max: 2
              }
            }
          ],
          xAxes: [
            {
              type: "time",
              time: {
                unit: "day"
              }
            }
          ]
        },
        tooltips: {
          enabled: false
        }
      }
    };
  },
  computed: {
    data() {
      return {
        datasets: [
          {
            data: this.missingDaysData,
            pointBackgroundColor: utils.colors.red,
            fill: true,
            pointRadius: 5,
            pointHoverRadius: 5
          },
          {
            data: this.activeDaysData,
            pointBackgroundColor: utils.colors.green,
            fill: true,
            pointRadius: 10,
            pointHoverRadius: 10
          }
        ]
      };
    }
  },
  mounted() {
    this.renderChart(this.data, this.options);
  }
};
</script>
